import { DocumentDirection } from '../config/DocumentDirection';

export const formatCurrency = (val, fractionDigits = 2) => {
  return new Intl.NumberFormat('hu-HU', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: fractionDigits,
  }).format(val);
};

export const formatNumber = (val) => {
  return new Intl.NumberFormat('hu-HU', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  }).format(val);
};

export const getRounding = (docDirection, currency) => {
  if (docDirection === DocumentDirection.INCOMING) {
    return currency?.purchasePriceRounding ?? 0;
  } else {
    return currency?.priceRounding ?? 0;
  }
};
